import * as React from 'react';
import AppContainer from './AppContainer';
import {CONTENT_TYPE} from '../../Config/appConfig';

class SettingsContainer extends React.Component <{}, {}> {
    public render() {
        return (
            <AppContainer content={CONTENT_TYPE.SETTINGS}/>
        );
    }
}

export default SettingsContainer;



// WEBPACK FOOTER //
// ./src/Components/Containers/SettingsContainer.tsx